import axios from "axios";
import { formatDate } from "../../../date";
import { initWeboothDetailChat } from "./chat";
/**
 * Webooth詳細周りの初期化
 */
export function initSampleSeriesWeboothDetail() {
    initFavoriteButton();
    initDownloadButton();
    initEstimateButton();
    initSaveMemoButton();
    initSeeMoreButton();
    initVideo();
    initOccupationButton();
    // チャット機能
    initWeboothDetailChat();
    updateVisitCount();
    // 担当者関連
    initSupplierStaffChangeButton();
    initSupplierStaffZoom();
}
/**
 * お気に入りボタンの初期化
 */
function initFavoriteButton() {
    const boxButton = document.querySelector("#sample-series-webooth-detail-favorite-button-box");
    const foxButton = document.querySelector("#sample-series-webooth-detail-favorite-button-fox");
    const texButton = document.querySelector("#sample-series-webooth-detail-favorite-button-tex");
    boxButton?.addEventListener("click", async () => {
        if (!boxButton.dataset.login) {
            window.open('/u/box/user/login');
        }
        const favorited = "favorited";
        if (boxButton.classList.contains(favorited)) {
            try {
                const id = boxButton.dataset.id;
                await axios.delete("/api/webooth-favorites/" + id);
                boxButton.classList.remove(favorited);
            }
            catch (error) {
                window.console.error(error);
            }
        }
        else {
            try {
                const json = boxButton.dataset.json;
                const data = JSON.parse(json);
                const res = await axios.post("/api/webooth-favorites", data);
                boxButton.dataset.id = res.data.id;
                boxButton.classList.add(favorited);
            }
            catch (error) {
                window.console.error(error);
            }
        }
    });
    foxButton?.addEventListener("click", async () => {
        if (!foxButton.dataset.login) {
            window.open('/u/fox/user/login');
        }
        const favorited = "favorited";
        if (foxButton.classList.contains(favorited)) {
            try {
                const id = foxButton.dataset.id;
                await axios.delete("/api/webooth-favorites/" + id);
                foxButton.classList.remove(favorited);
            }
            catch (error) {
                window.console.error(error);
            }
        }
        else {
            try {
                const json = foxButton.dataset.json;
                const data = JSON.parse(json);
                const res = await axios.post("/api/webooth-favorites", data);
                foxButton.dataset.id = res.data.id;
                foxButton.classList.add(favorited);
            }
            catch (error) {
                window.console.error(error);
            }
        }
    });
    texButton?.addEventListener("click", async () => {
        if (!texButton.dataset.login) {
            window.open('/u/tex/user/login');
        }
        const favorited = "favorited";
        if (texButton.classList.contains(favorited)) {
            try {
                const id = texButton.dataset.id;
                await axios.delete("/api/webooth-favorites/" + id);
                texButton.classList.remove(favorited);
            }
            catch (error) {
                window.console.error(error);
            }
        }
        else {
            try {
                const json = texButton.dataset.json;
                const data = JSON.parse(json);
                const res = await axios.post("/api/webooth-favorites", data);
                texButton.dataset.id = res.data.id;
                texButton.classList.add(favorited);
            }
            catch (error) {
                window.console.error(error);
            }
        }
    });
}
/**
 * 資料をもらうボタンの初期化
 */
function initDownloadButton() {
    const button = document.getElementById("sample-series-webooth-detail-download-button");
    if (button === null)
        return;
    button.addEventListener("click", function () {
        const downloadInputs = document.querySelectorAll('[id^="webooth-download-checkbox-"]');
        for (const input of downloadInputs) {
            input.checked = false;
        }
        const downloadQuestionnaireTable = document.getElementById("download-questionnaire-table");
        const completeQuestionnaireTable = document.getElementById("complete-questionnaire-table");
        if (downloadQuestionnaireTable !== null && completeQuestionnaireTable !== null) {
            if (downloadQuestionnaireTable.hasAttribute("hidden")) {
                completeQuestionnaireTable.setAttribute("hidden", "hidden");
            }
            const downloadInput1 = document.getElementById("download-questionnaire-input-1");
            const downloadInput2 = document.getElementById("download-questionnaire-input-2");
            const downloadInput3 = document.getElementById("download-questionnaire-input-3");
            const completeInput1 = document.getElementById("complete-questionnaire-input-1");
            const completeInput2 = document.getElementById("complete-questionnaire-input-2");
            const completeInput3 = document.getElementById("complete-questionnaire-input-3");
            if (downloadInput1 !== null) {
                downloadInput1.value = "";
            }
            if (downloadInput2 !== null) {
                downloadInput2.value = "";
            }
            if (downloadInput3 !== null) {
                downloadInput3.value = "";
            }
            if (completeInput1 !== null) {
                completeInput1.value = "";
            }
            if (completeInput2 !== null) {
                completeInput2.value = "";
            }
            if (completeInput3 !== null) {
                completeInput3.value = "";
            }
        }
        const downloadButton = document.getElementById("sample-series-webooth-download-button");
        downloadButton.disabled = true;
        const downloadMain = document.getElementById("sample-series-webooth-download-main");
        const completeMain = document.getElementById("sample-series-webooth-download-complete-main");
        downloadMain.style.display = "block";
        completeMain.style.display = "none";
        const modal = document.getElementById("sample-series-webooth-download-modal");
        modal.classList.add("is-show");
    });
}
/**
 * 見積を依頼するボタンの初期化
 */
function initEstimateButton() {
    const button = document.getElementById("sample-series-webooth-detail-estimate-button");
    if (button === null)
        return;
    button.addEventListener("click", function () {
        const estimateMain = document.getElementById("sample-series-webooth-estimate-main");
        const completeMain = document.getElementById("sample-series-webooth-estimate-complete-main");
        estimateMain.style.display = "block";
        completeMain.style.display = "none";
        const modal = document.getElementById("sample-series-webooth-estimate-modal");
        modal.classList.add("is-show");
    });
}
/**
 * 保存ボタンの初期化
 */
function initSaveMemoButton() {
    const button = document.getElementById("sample-series-webooth-detail-save-memo-button");
    if (button === null)
        return;
    const textarea = document.getElementById("sample-series-webooth-detail-memo-textarea");
    if (textarea === null)
        return;
    textarea.addEventListener("keyup", () => {
        button.disabled = false;
    });
    button.addEventListener("click", async () => {
        button.disabled = true;
        const memo = textarea.value;
        const id = button.dataset.id.trim();
        const userId = button.dataset.userId.trim();
        const weboothSlotId = button.dataset.weboothSlotId.trim();
        const data = {
            user_id: userId,
            webooth_slot_id: weboothSlotId,
            memo: memo,
        };
        try {
            let res = null;
            if (id === "") {
                res = await axios.post("/api/webooth-user-memo", data);
                button.dataset.id = res.data.id;
            }
            else {
                res = await axios.put(`/api/webooth-user-memo/${id}`, data);
            }
            if (res.data.id !== "") {
                alert("保存しました。");
            }
        }
        catch (error) {
            window.console.error(error);
            alert("メモの保存に失敗しました");
        }
    });
}
/**
 * もっと見るボタンの初期化
 */
function initSeeMoreButton() {
    const button = document.getElementById("see-more-button");
    if (button === null)
        return;
    button.addEventListener("click", function () {
        const list = document.getElementsByClassName("related-product");
        for (const item of list) {
            item.removeAttribute("hidden");
        }
        button.parentElement.removeChild(button);
    });
}
/**
 * 当該商品の紹介動画まわりの初期化
 */
function initVideo() {
    const video = document.getElementById("sample-series-webooth-detail-counting-video");
    if (video === null)
        return;
    let viewStartAt = new Date();
    let sec = 0;
    let timeoutId = null;
    const startTimer = () => {
        timeoutId = setTimeout(() => {
            sec += 1;
            startTimer();
        }, 1000);
    };
    video.addEventListener("pause", () => clearTimeout(timeoutId));
    video.addEventListener("seeking", () => clearTimeout(timeoutId));
    video.addEventListener("playing", () => startTimer());
    video.addEventListener("play", () => {
        if (sec === 0) {
            viewStartAt = new Date();
        }
    });
    video.addEventListener("ended", () => {
        if (sec >= 5) {
            postPlayHistoryData(video, sec, viewStartAt, false);
        }
        clearTimeout(timeoutId);
        sec = 0;
    });
    window.addEventListener("beforeunload", () => {
        if (sec >= 5) {
            postPlayHistoryData(video, sec, viewStartAt, true);
        }
        clearTimeout(timeoutId);
        sec = 0;
    });
}
/**
 * 視聴履歴データを送信する
 *
 * @param video ビデオタグ
 * @param sec 再生時間
 * @param viewStartAt 視聴開始時刻
 * @param useBeacon 送信にビーコンを使用するか
 */
async function postPlayHistoryData(video, sec, viewStartAt, useBeacon) {
    const data = JSON.parse(video.dataset.json);
    data.view_start_at = formatDate(viewStartAt, "Y/m/d H:i");
    data.time = sec;
    if (useBeacon) {
        const blob = new Blob([JSON.stringify(data)], { type: "application/json" });
        navigator.sendBeacon("/api/webooth-play-histories", blob);
        return;
    }
    try {
        await axios.post("/api/webooth-play-histories", data);
        const span = document.getElementById("sample-series-webooth-detail-play-count");
        if (span !== null) {
            const count = parseInt(span.innerText, 10) + 1;
            span.innerText = count.toString();
        }
    }
    catch (error) {
        window.console.error(error);
    }
}
/**
 * すべて表示ボタンの初期化（対象業種）
 */
function initOccupationButton() {
    const button = document.getElementById("sample-series-webooth-detail-occupation-button");
    if (button === null)
        return;
    button.addEventListener("click", () => {
        const elements = document.getElementsByClassName("sample-series-webooth-detail-occupation");
        for (const element of elements) {
            const a = element;
            a.style.display = "inline-block";
        }
        button.style.display = "none";
    });
}
/**
 * 訪問数の更新
 */
async function updateVisitCount() {
    const span = document.getElementById("sample-series-webooth-detail-visit-count");
    if (span === null)
        return;
    try {
        const data = JSON.parse(span.dataset.json);
        await axios.post("/api/webooth-visit-histories", data);
        const count = parseInt(span.innerText, 10) + 1;
        span.innerText = count.toString();
    }
    catch (error) {
        window.console.error(error);
    }
}
/**
 * 担当者切替
 */
function initSupplierStaffChangeButton() {
    const buttons = document.querySelectorAll(".supplier-staff-change");
    if (buttons === null)
        return;
    for (const button of buttons) {
        button.addEventListener("click", () => {
            const stafIndex = button.dataset.supplierstaffchangeindex;
            if (stafIndex === null)
                return;
            const displayAreas = document.querySelector("#webooth-supplier-staff-display-area");
            if (displayAreas === null)
                return;
            const areaRect = displayAreas.getBoundingClientRect();
            //window.console.log(areaRect);
            const displayContents = document.querySelector("#webooth-supplier-staff-display-" + stafIndex);
            if (displayContents === null)
                return;
            const contentsRect = displayContents.getBoundingClientRect();
            //window.console.log(contentsRect);
            const relativeTop = contentsRect.top - areaRect.top;
            const nowScrollTop = displayAreas.scrollTop;
            displayAreas.scrollTop = nowScrollTop + relativeTop;
            //window.console.log(displayAreas);
            for (const buttonSub of buttons) {
                buttonSub.style.opacity = "1";
            }
            button.style.opacity = "0.7";
        });
    }
}
/**
 * 担当者拡大表示
 */
function initSupplierStaffZoom() {
    const jsIntegration = JSON.parse(document.querySelector("#js-integration")?.innerHTML || "{}");
    if (jsIntegration.me !== undefined && jsIntegration.me.id === null) {
        return;
    }
    const area = document.querySelector("#webooth-supplier-staff-display-area");
    if (area === null)
        return;
    const Staffs = document.querySelectorAll("article");
    if (Staffs === null)
        return;
    for (const Staff of Staffs) {
        Staff.addEventListener("mouseover", () => {
            const stafIndex = Staff.dataset.zoomindex;
            if (stafIndex === null)
                return;
            const displayAreas = document.querySelector("#webooth-supplier-staff-zoom-area-" + stafIndex);
            if (displayAreas === null)
                return;
            displayAreas.style.display = "block";
        });
    }
    const displayAreas = document.querySelectorAll(".charge-content-zoom");
    if (displayAreas === null)
        return;
    for (const displayArea of displayAreas) {
        displayArea.addEventListener("mouseleave", () => {
            displayArea.style.display = "none";
        });
    }
}
